import CustomModal from "components/new-stuff/ui/modals/CustomModal"
import { Button } from "components"
import { Divider } from "antd"
import { useNavigate } from "react-router-dom"

export const TimesheetEntryOptionsModal = ({
  open,
  onClose,
  setShowManualEntry,
}: {
  open: boolean
  setShowManualEntry: (value: boolean) => void
  onClose: () => void
}) => {
  const navigate = useNavigate()

  return (
    <CustomModal
      open={open}
      onCancel={onClose}
      title="Create manual entry"
    >
      <div className="font-circular">
        <div>
          <p className="font-medium text-sm mb-1">
            Type in your manual entry in the next page.
          </p>
          <Button
            onClick={() => {
              onClose()
              setShowManualEntry(true)
            }}
            color="primary"
            style={{ fontWeight: "initial", width: "100%" }}
          >
            Create entry online
          </Button>
        </div>
        <Divider plain>
          <span className="text-[#90A1B9]">OR</span>
        </Divider>
        <div>
          <p className="font-medium text-sm mb-2">
            Submit a sheet you've prepared.
          </p>
          <Button
            onClick={() => {
              onClose()
              navigate(
                "/employee/dashboard/time-and-attendance/time-sheet/upload-timesheet"
              )
            }}
            color="neutral-outline"
            style={{ color: "black", fontWeight: "initial", width: "100%" }}
          >
            Submit CSV
          </Button>
        </div>
      </div>
    </CustomModal>
  )
}
